// Brand colors, kept in step with the host app's palette (native-in-hospital-app's
// src/palette/styles/styled.ts) so both can eventually pull overrides from the same source.
const ccPalette = {
  indigo200: '#d2dfed',
  indigo300: '#afc6dd',
  indigo400: '#90acc9',
  indigo600: '#39648d',
  indigo800: '#042949',
  blue50: '#f2f8ff',
  blue600: '#1f7bff',
  blue700: '#0056d1',
  blue500A20: '#4897ff33',
  white: '#ffffff',
};

const theme = {
  config: {
    initialColorModeName: 'light',
    useColorSchemeMediaQuery: false,
  },
  breakpoints: ['40em', '64em'],
  colors: {
    // Semantic names match the host app 1:1 (primary, primaryText, cardBackground, ...) so a
    // colour override can be applied under the same key in both places.
    primary: ccPalette.blue600,
    primaryDark: ccPalette.blue700,
    primaryText: ccPalette.indigo800,
    primaryTextLight: ccPalette.indigo600,
    disabled: ccPalette.indigo300,
    border: ccPalette.indigo200,
    borderDark: ccPalette.indigo400,
    background: ccPalette.white,
    backgroundSecondary: ccPalette.blue50,
    cardBackground: ccPalette.white,
    white: ccPalette.white,
    modalBackground: ccPalette.blue500A20,
    modes: {
      dark: {
        primary: '#1f7bff',
        primaryDark: '#c9deff',
        primaryText: '#e8f1fb',
        primaryTextLight: '#9bb5d4',
        disabled: '#3d5977',
        border: '#27425a',
        borderDark: '#5a7a9e',
        background: '#090d10',
        backgroundSecondary: '#0a1929',
        cardBackground: '#0f1319',
        modalBackground: '#7ca3d433',
      },
    },
  },
  fonts: {
    body: 'Muli, system-ui, sans-serif',
    heading: 'Muli, system-ui, sans-serif',
    monospace: 'monospace',
  },
  fontWeights: {
    body: 500,
    heading: 700,
    bold: 700,
  },
  // rem based so the root font-size set by the size preference scales the whole page.
  fontSizes: ['0.75rem', '0.875rem', '1rem', '1.125rem', '1.25rem', '1.375rem', '1.5rem', '2rem', '2.25rem', '2.5rem'],
  space: [
    0,
    '0.25rem',
    '0.5rem',
    '0.75rem',
    '1rem',
    '1.25rem',
    '1.5rem',
    '1.75rem',
    '2rem',
    '2.25rem',
    '2.5rem',
    '3rem',
    '4rem',
  ],
  radii: { 0: 0, 1: 4, 2: 8, 3: 12, 4: 16, card: 20, image: 12 },
  shadows: {
    card: '0 2px 8px 0 rgba(4, 41, 73, 0.08)',
    cardHover: '0 8px 20px 0 rgba(4, 41, 73, 0.16)',
  },
  text: {
    heading: {
      fontFamily: 'heading',
      fontWeight: 'heading',
      color: 'primaryText',
    },
  },
  styles: {
    root: {
      fontFamily: 'body',
      fontWeight: 'body',
      fontSize: 2,
      color: 'primaryText',
      bg: 'background',
    },
    h1: {
      variant: 'text.heading',
      fontSize: [5, 6],
      lineHeight: 1.2,
      m: 0,
    },
    h2: {
      variant: 'text.heading',
      fontSize: 3,
      lineHeight: 1.3,
      m: 0,
    },
  },
  buttons: {
    toggle: {
      cursor: 'pointer',
      bg: 'cardBackground',
      color: 'primary',
      border: '1px solid',
      borderColor: 'primary',
      borderRadius: '999px',
      fontFamily: 'body',
      fontWeight: 'bold',
      fontSize: 1,
      px: 3,
      py: 2,
      // Scales with the size preference but never drops below the 44px touch target.
      minHeight: 'max(2.75rem, 44px)',
      touchAction: 'manipulation',
      WebkitTapHighlightColor: 'transparent',
      '&[aria-pressed="true"]': {
        bg: 'primary',
        color: 'white',
        borderColor: 'primary',
      },
      '&:active': {
        transform: 'scale(0.97)',
      },
    },
  },
};

export default theme;
